// Refined MovaRaBoard mark — operational board lanes with a movement node.
export function MovaraMark({ className = "h-5 w-5" }) {
  return (
    <svg viewBox="0 0 28 24" className={className} fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <rect x="1.5" y="7" width="3.6" height="15" rx="1" fill="currentColor" opacity="0.4" />
      <rect x="7.6" y="3.5" width="3.6" height="18.5" rx="1" fill="currentColor" opacity="0.62" />
      <rect x="13.7" y="9.5" width="3.6" height="12.5" rx="1" fill="currentColor" opacity="0.85" />
      <rect x="19.8" y="5.5" width="3.6" height="16.5" rx="1" fill="currentColor" opacity="1" />
      <circle cx="25.2" cy="3.4" r="2.2" fill="currentColor" />
    </svg>
  );
}
